export default __webpack_public_path__ + "static/media/control-stop.69963cf6.png";